import { useAppSelector } from '../../../../../state/hooks'
import { selectAutoTaxInactiveCategoryLineItemIds } from '../../../../../state/slices/currentSale/currentSaleSlice'

export const useHasOutdatedTaxCategory = (
  lineItemId: string | undefined
): boolean => {
  const inactiveCategoryLineItemIds = useAppSelector(
    selectAutoTaxInactiveCategoryLineItemIds
  )
  return (
    !!lineItemId && (inactiveCategoryLineItemIds?.includes(lineItemId) ?? false)
  )
}
